export const TOGGLE_LOADER = 'TOGGLE_LOADER';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_CART = 'UPDATE_CART';
export const UPDATE_PRICE = 'UPDATE_PRICE';
